<div class="container py-3">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item" aria-current="page">
        <a class=" text-decoration-none">
          <fa-icon icon="building-columns"></fa-icon>
          <span jhiTranslate="global.menu.institutions">institutions</span>
        </a>
      </li>
    </ol>
  </nav>

  <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
    <div class="col d-flex align-items-stretch">
      <div class="card mb-4 rounded-3">
        <div class="card-header py-2  text-primary border-primary">
          <h4 class="my-0 fw-normal">Support Paket</h4>
        </div>
        <div class="card-body card-body d-flex flex-column">
          <div class="text-start">
            Sie suchen eine Sexualbegleitung und wünschen sich eine individuelle Unterstützung von der Evaluation und
            Planung
            über Finanzierung bis zur Begegnung. Dann ist unser bedürfnisorientiertes sexcare Paket die richtige Wahl!
          </div>
          <a (click)="goToSupport()" class="mt-auto">mehr</a>
        </div>
      </div>
    </div>

    <div class="col d-flex align-items-stretch">
      <div class="card mb-4 rounded-3">
        <div class="card-header py-2  text-primary border-primary">
          <h4 class="my-0 fw-normal">Expert Paket</h4>
        </div>
        <div class="card-body card-body d-flex flex-column">
          <div class="text-start">
            Als Wohn- und/oder Arbeitsgemeinschaft wünschen Sie sich Unterstützung bei Arbeiten an Ihrem Sexualkonzept
            unter Einbezug von entsprechenden Experten aus Sexualbegleitung, Berufsbeistandschaft, KESB, Dozenten HSL?
            Dann ist unser lösungsorientiertes sexcare Expert Paket die richtige Wahl!
          </div>
          <a (click)="goToExpert()" class="mt-auto">mehr</a>
        </div>
      </div>
    </div>

    <div class="col d-flex align-items-stretch">
      <div class="card mb-4 rounded-3">
        <div class="card-header py-2  text-primary border-primary">
          <h4 class="my-0 fw-normal">Fach- / Podiumsgespräche</h4>
        </div>
        <div class="card-body d-flex flex-column">
          <div class="text-start">
            Sie interessieren sich als soziale Einrichtung, Interessengemeinschaft, Verein oder Club für einen
            praxisorientierten und exklusiven Beitrag aus erster Hand zum Thema Sexualität und Einschränkung oder Lust
            im reifen Alter?
          </div>
          <a (click)="goToFach()" class="mt-auto">mehr</a>
        </div>
      </div>
    </div>
  </div>

  <section class="">
    <h5 class="mb-3 mt3 fw-bold text-uppercase text-center text-primary">Rückmeldungen</h5>
    <hr class="w-60 mx-auto "/>
    <div class="row g-2">
      <div class="col-md-6">
        <div class="card p-3 text-center px-4 shadow-sm">
          <div class="user-image">
            <!-- <img src="https://i.imgur.com/w2CKRB9.jpg" class="rounded-circle" width="80"> -->
          </div>
          <div class="user-content">
            <h5 class="mb-0">Dr. med. Werner Tschan</h5>
            <span>Psychiatrie FMH</span>
            <p>Liebe Frau Kölbl
              Herr A.M. steht seit dem 03.11.2014 wegen einer Hirnleistungsschwäche, bestehend seit Geburt, in meiner
              Behandlung. Er bezieht aufgrund seiner gesundheitlichen Einschränkung eine volle Rente der Eidgen.
              Invalidenversicherung, Herr A.M. leidet unter erheblichen Beziehungsschwierigkeiten bedingt durch seine
              Behinderung. Dank der Sexualbegleitung hat sich das-Befinden von Herrn A.M. deutlich entspannt. Für ihn
              sind
              <q>Mauern weggefallen</q> er fühlt sich in seiner Identität als Mann bestätigt und er ist seither in
              sozialen
              Kontakten weniger verklemmt und gehemmt. Bis zur jetzigen Sexualbegleitung hatte Herr A.M. noch nie einen
              intimen Kontakt mit einer Frau – was für ihn mit einer erheblichen Einschränkung der Lebensqualität
              verbunden gewesen war. Der Besuch bei Ihnen bereitete Herrn A.M. anfänglich grosse Schwierigkeiten –
              inzwischen ist er in der Lage, Sie anzurufen und selbstständig einen Besuch bei Ihnen zu vereinbaren. Ich
              danke Ihnen für Ihr Engagement. Sie haben Herrn A.M. viel geholfen. Falls Sie diesen Text veröffentlichen
              wollen, dann nur in anonymisierter Form. Herr XY möchte nicht, dass sein Name erwähnt wird. Mich dürfen
              Sie selbstverständlich erwähnen. </p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card p-3 text-center px-4 shadow-sm">
          <div class="user-image">
          </div>
          <div class="user-content">

            <h5 class="mb-0">Heidi</h5>
            <span>Privatbeiständin</span>
            <p>Als Folge eines Schlaganfalls im Alter von 72 Jahren ist Hans an beiden Händen und Beinen gelähmt und
              wohnt in einem Pflegezentrum der Stadt Zürich, wo er sehr gut betreut wird. Ich habe vor fünf Jahren seine
              Beistandschaft übernommen und mit ihm eine gute Vertrauensbasis aufbauen können. Vor ca. 1 1/2 Jahren
              erfuhr ich über die Sozialarbeiterin des Pflegezentrums von seinem Wunsch nach einer Berührerin. In einem
              persönlichen Gespräch erklärte ich ihm, dass ich seinen Wunsch verstehe und ihm bei der Einteilung seines
              bescheidenen Einkommens unterstützen würde, damit sein Wunsch in Erfüllung geht. Wir gaben der
              Sozialarbeiterin grünes Licht für die Organisation eines Besuches – kurz vor seinem 80. Geburtstag.
              Melanie’s Besuch hat Hans sichtlich sehr glücklich gemacht, sodass ich gegen einen nächsten Besuchswunsch
              nichts einwenden konnte. Als ich dann einmal Hans etwas im Pflegezentrum vorbeibrachte, fand ich ihn in
              der Cafeteria mit Melanie am Kaffee Trinken – zufälligerweise nach diesem zweiten Besuch – und durfte sie
              als sehr liebe Person kennenlernen. Da die Besuche nicht zu häufig stattfinden, bleiben sie etwas
              Spezielles, worauf sich Hans länger freuen kann, und finanziell
              tragbar (das ist halt meine Aufgabe). Ich gönne Hans die glücklichen Momente mit Melanie von Herzen.
              Heidi, Privatbeiständin</p>

          </div>
        </div>
      </div>
    </div>
    <p class="mt-3 fw-bold">
      Ihre Rückmeldung und Erfahrung verschafft Beauftragten einen ersten Einblick und macht Suchenden Mut
    </p>
    <ul class="mt-3 mb-4">
      <li>Art Ihrer Einrichtung/Institution/Praxis</li>
      <li>Ihre Funktion</li>
      <li>Was war Ihr Wunsch/Anliegen/Auftrag</li>
    </ul>
    <p>
      Und wer weiss, vielleicht sind Sie schon bald <q>mitschuldig</q> an glücklichen Momenten Anderer... <br>
    </p>
  </section>

  <div class=" mt-5 mb-5 py-5 rounded-3" style="background-color: #eaeaea;">
    <div class="text-center">
      <h4 class="text-uppercase text-primary">Ihre Ansprechperson</h4>
      <hr class="w-60 mx-auto"/>
    </div>
    <div class="m-2 d-flex gap-5 align-items-center h-100">
      <div class="row">
        <div class="col-5">
          <img
            src="/../../../content/images/ik_logo.png"
            alt=""
            class="about-img img-fluid rounded-circle"
          />
        </div>
        <div class="col">
          <p class="lead">
            Isabelle Kölbl, Sexualbegleiterin. Gründerin Sexcare mit
            Lehrauftrag an der FHNW.
            <br>
            <a href="mailto:info@sexcare.ch">info&#64;sexcare&#46;ch</a>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div id="support">
    <h3 class="mb-4 text-primary">Support Paket</h3>

    <h5 class="text-primary">Sexualbegleitung evaluieren, planen, durchführen</h5>
    <p>
      <q>Es wäre eigentlich alles sehr einfach…wenn natürlicher mit der Sexualität umgegangen wird, wenn sie ihre
        Berechtigung, ihren Raum erhält, dann verliert sie das Bild des grossen Ungeheuers, voller Problematik und
        Angst…dann wird sie zur friedvollen, wunderbaren, zärtlichsten Sprache der Welt……Sexualität wird zu einer
        erweiterten Form der Kommunikation. Alles was es dazu braucht sind sensibilisierte, geschulte Menschen.</q>
    </p>

    <h5 class="text-primary">Umfang</h5>
    <p>Sie suchen eine Sexualbegleitung und wünschen sich individuelle Unterstützung von der Evaluation und Planung über
      Finanzierung bis zur Begegnung
    </p>
    <h5 class="text-primary">Ziel</h5>
    <p>
      Mit möglichst gut strukturierter Vorarbeit den Freiraum schaffen, um Sexualität praktisch stattfinden zu lassen,
      nach den Wünschen des Betroffenen, in der Form, dass alle Beteiligten dahinter stehen können.
    </p>
  </div>
  <div id="expert">
    <h3 class="mb-4 text-primary">Expert Paket</h3>
    <p>
    <h5 class="text-primary">Arbeiten an Ihrem Sexualkonzept</h5>
    <p><q>In der Bundesverfassung heisst es: Das Recht auf Sexualität untersteht dem Grundrecht der persönlichen
      Freiheit. Menschen mit einer Behinderung/Beeinträchtigung haben demnach das Recht, ihre Gefühle, ihre Sinnlichkeit
      und ihre Sexualität zu leben</q>

    <h5 class="text-primary">Umfang</h5>
    <p>Als Wohn- und/oder Arbeitsgemeinschaft wünschen Sie sich Unterstützung bei Arbeiten an Ihrem Sexualkonzept unter
      Einbezug von entsprechenden Experten aus Sexualbegleitung, Berufsbeistandschaft, KESB, Dozenten HSL
    </p>
    <h5 class="text-primary">Ziel</h5>
    <p>Die innere Haltung Ihrer Institution zur Sexualität formulieren und deren Umsetzung im Heimalltag ermöglichen.
    </p>
  </div>
  <div id="fach">
    <h3 class="mb-4 text-primary">Fach- und Podiumsgespräche</h3>
    <p>
      Sie interessieren sich als soziale Einrichtung, Interessengemeinschaft, Verein oder Club für einen
      praxisorientierten und exklusiven Beitrag aus erster Hand zum Thema Sexualität und Einschränkung, Lust im reifen
      Alter.
    </p>
    <h5 class="text-primary">Inhalt / Schwerpunkte</h5>
    <ul>
      <li>Im Rahmen einer allgemeinen oder differenzierteren Fortbildung</li>
      <li>Als informativer Beitrag über die Arbeit von Isabelle Kölbl als Sexualbegleiterin und Gründerin von sexcare
      </li>
      <li>In Anlehnung an Ihr Sexualkonzept als Anwendungs- und Umsetzungshilfe für die Belegschaft</li>
    </ul>
    <h5 class="text-primary">Fachgespräch</h5>
    Zeitlicher Rahmen und Inhalt auf Ihren Schwerpunkt ausgerichtet
    Referentin: Frau Isabelle Kölbl
    <h5 class="text-primary">Podiumsgespräch</h5>
    <p>
      Unter Einbezug von Betroffenen, ausgerichtet nach Ihrer Firmenstruktur
      Moderation und Organisation: Frau Isabelle Kölbl
    </p>
  </div>
</div>
